import { useState, useEffect, useCallback } from 'react';
import { apiFetch } from "../utils/api";

export default function useEmissionPoints() {
  const [emissionPoints, setEmissionPoints] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reloadIndex, setReloadIndex] = useState(0);

  const reload = useCallback(() => setReloadIndex(i => i + 1), []);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    setError(null);

    apiFetch('/api/emission-points')
      .then(async res => {
        if (!res) {
          if (isMounted) {
            setEmissionPoints([]);
            setError("No response from server");
          }
          return;
        }

        if (res.status === 403) {
          if (isMounted) {
            setEmissionPoints([]);
            // setError("You do not have permission to view emission points");
          }
          return;
        }

        if (res.ok) {
          const data = await res.json();
          if (isMounted) setEmissionPoints(data);
        } else {
          if (isMounted) {
            setEmissionPoints([]);
            setError(`HTTP error ${res.status}`);
          }
        }
      })
      .catch(err => {
        if (isMounted) {
          console.error("Unexpected error in useEmissionPoints:", err);
          // setError("Unexpected error");
        }
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [reloadIndex]);

  return { emissionPoints, loading, error, reload };
}
